import { ApiResultVoBoolean } from '@schemas/non-auth'
import { createPrefetchQuery } from '@utils/createPrefetchQuery'
import { AreaDiv, InfluxDiv } from '../types'
import { fetchAPI } from '@utils/http/apiRequest'

export type StatisticsArticlePVResponse = CommonResponse<ApiResultVoBoolean>

export interface StatisticsArticlePVReqModel {
	articleIdx: string
	influxDiv?: InfluxDiv
	areaDiv?: AreaDiv
	areaIdx?: string
}

const path = '/restapi/v1/post/statistics/article-pv'
const queryKeyString = (props?: StatisticsArticlePVReqModel) =>
	['@statistics/article-pv', props] as const

const getQuery = async (props: StatisticsArticlePVReqModel, cookieHeader?: string) => {
	const { articleIdx, influxDiv, areaDiv, areaIdx } = props
	const params = new URLSearchParams({
		...(articleIdx ? { articleIdx } : {}),
		...(influxDiv ? { influxDiv } : { influxDiv: 'ETC' }),
		...(areaDiv ? { areaDiv } : { areaDiv: 'ETC' }),
		...(areaIdx ? { areaIdx } : { areaIdx: 'ETC' }),
	})
	return fetchAPI({ path, params, method: 'POST', cookieHeader })
}

export const queryStatisticsArticlePV = (
	props: StatisticsArticlePVReqModel,
	cookieHeader?: string,
) => ({
	queryKey: queryKeyString(props),
	queryFn: () => getQuery(props, cookieHeader),
})

export const prefetchStatisticsArticlePV = (
	props: StatisticsArticlePVReqModel,
	cookieHeader?: string,
) => createPrefetchQuery(queryKeyString(props), () => getQuery(props, cookieHeader))
